import { createFileRoute } from '@tanstack/react-router';

import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { AccountingSettingsPage } from '@/pages/settings/accounting/AccountingSettingsPage';

export const Route = createFileRoute('/_authenticated/_app/settings/invoicing/accounting')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['invoicing.configure'] }),
	component: AccountingSettingsPage,
});
